import React, { Component  } from 'react';
import { SafeAreaView , View, Text, TextInput,ActivityIndicator , TouchableOpacity  , Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import GestureRecognizer, {swipeDirections} from 'react-native-swipe-gestures';
import { connect } from 'react-redux';
import NetInfo from "@react-native-community/netinfo";
import { GetOrderList , SearchOrder } from "../../actions/orderActions";
import {SearchScanpackOrder} from "../../actions/scanpackAction";
import { SetItem , GetItem } from "../../actions/updateAsyncAction";
import {GetGeneralSetting , GetScanPackSetting , UserInfo} from "../../actions/userAction";
import globalStyles from '../../style/global';
import styles from '../../style/scanpack';
import PopUpModel from "./pop_up_model";

let orderListSuccess = false;
let searchOrderSuccess = false;
let validateUser = false
let messageShow = false

class ScanPack extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data:{
        "input": "",
        "state": "scanpack.rfo",
        "id": null,
        "box_id": null,
        "store_order_id": null,
        "app": "app"
      },
      popUpModelShow: false,
      dataList:{
          "filter": "",
          "order": "DESC",
          "limit": "1",
          "offset": "0",
          "app": "app",
          "count": 0
      },
      orderDetail: null,
      rfoTitle: "Scan the Packing Slip of an Order you'd like to Pack.",
      time: new Date(),
      loading: false,
      loaderTitle: "",
      userInfo: "",
      scan_pack_settings: null
    };
    this.inputFocus = React.createRef();
    this.searchOrder = this.searchOrder.bind(this);
  }

  componentDidMount(){
    this.props.UserInfo()
    this.setState({loading: true , loaderTitle: "Loading..."})
    this.getOrder()
    validateUser = true
  }

  //According to the platform call the function
  getOrder = () => {
    if(Platform.OS === "ios" || Platform.OS === "android"){
      this.checkConnection("apiCall")
    }else{
      this.apiCall()
    }
  }

  alertBox = (message , skip , messageTypeSuccess) => {
    if(messageTypeSuccess === true){
      this.setState({popUpModelShow: true , message: message, messageTypeSuccess: true})
    }else{
      this.setState({popUpModelShow: true , message: message})
    }
    setTimeout(function(){
      this.setState({popUpModelShow: false , message: "" , messageTypeSuccess: false});
    }.bind(this),4000);
    // try {
    //   this.barcode.current.focus()
    // } catch (error) {
    // }
  }

  //Check the connection for the ios and android
  checkConnection = async(type , input) => {
    const connectionInfo = await NetInfo.fetch();
    if(connectionInfo.isConnected){
      type === "callShipmentOrder" ? this.callShipmentOrder(input) : this.apiCall()
    }else{
      this.setState({rfoTitle: "Please check your internet connection"})
    }
  }

  //Call the api to fetch the data from backend
  apiCall = () => {
    this.props.GetOrderList(this.state.dataList);
    orderListSuccess = true
  }


  componentDidUpdate(){
    
    //OrderList + scanpacksetting + general setting
    if(orderListSuccess === true && this.props && this.props.ordersList && this.props.ordersList !== this.state.list){
      orderListSuccess = false
      let list = this.props.ordersList
      let orderShow = list.orders.length === 0 ? true : false
      this.setState({ scan_pack_settings: list.scan_pack_settings , 
                      general_settings: list.general_settings,
                      rfoTitle: list.orders.length > 0 ? list && list.orders[0] && list.orders[0].ordernum : "No orders were found in the awaiting orders list.",
                      //rfoTitle: list.orders.length > 0 ? list && list.orders[0] && list.orders[0].ordernum : "Please scan an order to continue." ,
                      orderDetail: list && list.orders && list.orders[0],
                      loading: false,
                      list: this.props.ordersList,
                      unClick: orderShow
                    })
    }

    // else{
    //   if(orderListSuccess === true && this.props && this.props.ordersList === undefined){
    //     // messageShow  === false
    //     orderListSuccess = false
    //     this.setState({ 
    //                   rfoTitle: "Oops....Something went wrong.",
    //                   loading: false
    //                 })
    //   }
    // }


      this.setFocus()

    if(messageShow === false && this.props && this.props.route && this.props.route.params && this.props.route.params.showScannedMessage){
        this.alertBox(`The order has already been scanned.`, true , true)
        this.setState({loading: true , loaderTitle: "Loading..."})
        this.getOrder()
        messageShow = true
    }

    //Search Order Data
    if(searchOrderSuccess === true && this.props && 
        this.props.searchOrder && this.props.searchOrder.time > this.state.apiCallTime &&  
          this.props.searchOrder !== this.state.oldOne){
      let searchResult = this.props.searchOrder && this.props.searchOrder.searchOrder
      let order =  searchResult && searchResult.data.order && searchResult.data.order[0]
      if(searchResult){
        if(searchResult.matched){
          if(searchResult.data){
              this.orderDetails(order) 
              searchOrderSuccess = false
            }else{
              if(searchResult.data.status === "scanned"){
                let message = `Order ${searchResult.data.order_num} has already been scanned.` 
                this.statusFunction(message)
                this.setState({unClick: true})
              }
            }
        }else{
          this.statusFunction(searchResult.error_messages)
          this.setState({unClick: true})
          searchOrderSuccess = false
        }
        this.setFocus() 
        let data = this.state.data
        data["input"] = ""
        this.setState({oldOne: this.props.searchOrder ,data ,loading: false })
      }
    }

    if(validateUser && this.props && this.props.userInfo && this.props.userInfo !== this.state.userInfo){
      if(this.props.userInfo.is_active === false){
        validateUser = false
        this.props.UserInfo(false)
        this.redirect()
      }
    }

  }

  closeAlert = () => {
    this.setState({ popUpModelShow: false })
  }

  redirect = async() => {
    // await AsyncStorage.removeItem("access_token")
    await AsyncStorage.clear();
    this.props.navigation.navigate("SignIn",{ status: "Inactive" , time: new Date()})
    this.setState({userInfo: this.props.userInfo})
  }

  //After the apis call update the status (scanned , order  not present)
  statusFunction = (message) => {
    let data = this.state.data
    data["input"] = ""
    this.setState({rfoTitle: message , data})
  }

  //To set the focus
  setFocus = () => {
    this.inputFocus.current.focus();
  }

  //Redirect to the scanpackItem page with order details 
  orderDetails = (order) => {
    if(order && order.scan_hash && order.scan_hash.data){
      this.props.navigation.navigate("ScanPackItem" , {data: order.scan_hash.data})
      messageShow = false
    }
  }

  //Check the connection for mobile device before call the api
  searchOrder = (input) => {
    this.setState({loading: true , loaderTitle: "Loading..."})
    if(input !== ""){
      if(Platform.OS === "ios" || Platform.OS === "android"){
        this.checkConnection("callShipmentOrder", input)
      }else{
        this.callShipmentOrder(input)
      }
    }
  }

  //Api to call the search order
  callShipmentOrder = (input) => {
    let shipmentOrder = this.state.data
    shipmentOrder["input"] = input
    if(input !== ""){
      shipmentOrder.input = input
      this.props.SearchScanpackOrder(shipmentOrder)
      searchOrderSuccess = true
      let apiCallTime = new Date()
      this.setState({apiCallTime})
    }
  }

  //Handle the search field input
  handleChange = (name , value) => {
    let order =  this.state.data;
    if(name === "searchOrder"){
      order["input"] = value
    }
    this.setState({order})
  }

  componentWillUnmount(){
    this.props.GetOrderList(this.state.dataList,false)
  }

  render() {
    return (
      <SafeAreaView style={globalStyles.flex1}>
        <View style={globalStyles.flexDirectionRow}>
          <TextInput placeholder="Type order to search"
                     name="searchOrder"
                     autoFocus={true}
                     ref={this.inputFocus}
                     value={this.state.data.input}
                     onChangeText={(text) => {this.handleChange("searchOrder", text)}}
                     onSubmitEditing={() => {this.searchOrder(this.state.data && this.state.data.input)}}
                     style={styles.inputBox}/>
        </View>
        { // Notification Pop Up for messages
          this.state.popUpModelShow &&
            <PopUpModel closeAlert={this.closeAlert.bind(this)}
                        message={this.state.message}
                        messageTypeSuccess={this.state.messageTypeSuccess ? true : false}
                        />
        }
        <View style={styles.container}>
          {
            this.state.loading
              ?
              <View style={{flex: 1 , justifyContent: "center"}}>
                <ActivityIndicator size="large" color="#336599"/>
                <Text style={{fontSize: 13 , fontWeight: 500}}>{this.state.loaderTitle}</Text>
              </View>
              :
              <>
                {
                  this.state.error
                  ?
                    <Text style={styles.text}>
                      {this.state.error}
                    </Text>
                  :
                    <React.Fragment>
                    {
                      this.state.unClick
                      ?
                        <Text style={styles.text}>
                            {this.state.rfoTitle}
                        </Text>
                      :
                        <TouchableOpacity 
                          onPress={() => this.searchOrder(this.state.rfoTitle)}
                          >
                          <Text style={styles.text}>
                              {this.state.rfoTitle}
                          </Text>
                        </TouchableOpacity>
                    }
                    </React.Fragment>  
                }
              </>   
          }
        </View>
      </SafeAreaView>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ordersList: state.order.list,
    searchOrder: state.scanpack,
    userInfo: state.user.userInfo
  }
};

const mapDispatchToProps = {
  GetOrderList,
  SearchScanpackOrder,
  UserInfo
};

export default connect(mapStateToProps, mapDispatchToProps)(ScanPack)
